import React from 'react';
import { XIcon, CheckIcon, ZapIcon } from 'lucide-react';
export function BeforeAfter() {
  return <section className="relative overflow-hidden" data-id="element-1">
      {/* Section label */}
      <div className="bg-[#1A1A2E] py-10 text-center" data-id="element-2">
        <h2 className="text-[56px] sm:text-[72px] lg:text-[88px] text-white leading-none" style={{
        fontFamily: "'Bebas Neue', sans-serif"
      }} data-id="element-3">
          THE{' '}
          <span className="text-[#4361EE] glow-text-blue" data-id="element-4">TRANSFORMATION</span>
        </h2>
      </div>

      {/* Split section */}
      <div className="flex flex-col lg:flex-row min-h-[600px]" data-id="element-5">
        {/* BEFORE — left */}
        <div className="flex-1 relative px-8 sm:px-12 py-16 flex flex-col justify-center" style={{
        background: 'linear-gradient(135deg, #1A0A0A 0%, #2D0A1A 50%, #1A0A0A 100%)'
      }} data-id="element-6">
          {/* Background texture */}
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #F72585 0, #F72585 1px, transparent 0, transparent 50%)',
          backgroundSize: '20px 20px'
        }} data-id="element-7" />

          <div className="relative max-w-lg mx-auto lg:ml-auto lg:mr-16" data-id="element-8">
            <div className="flex items-center gap-3 mb-8" data-id="element-9">
              <div className="w-3 h-3 rounded-full bg-[#F72585]" data-id="element-10" />
              <h3 className="text-[#F72585] text-[52px] sm:text-[64px] leading-none glow-text-pink" style={{
              fontFamily: "'Bebas Neue', sans-serif"
            }} data-id="element-11">
                BEFORE ADHD RESET
              </h3>
            </div>

            <div className="space-y-5" data-id="element-12">
              <BeforeItem text="Scattered across 12 open tabs and 3 half-written notes" data-id="element-13" />
              <BeforeItem text="Overwhelmed before the day even starts" data-id="element-14" />
              <BeforeItem text="Promising yourself 'tomorrow will be different'" data-id="element-15" />
              <BeforeItem text="Watching deadlines blow past in slow motion" data-id="element-16" />
              <BeforeItem text="Feeling like everyone else got the manual you didn't" data-id="element-17" />
            </div>
          </div>
        </div>

        {/* Center divider */}
        <div className="relative flex items-center justify-center z-10 lg:w-20" data-id="element-18">
          <div className="hidden lg:flex flex-col items-center h-full" data-id="element-19">
            <div className="flex-1 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent" data-id="element-20" />
            <div className="w-14 h-14 rounded-full flex items-center justify-center glow-blue" style={{
            background: '#1A1A2E',
            border: '2px solid #4361EE'
          }} data-id="element-21">
              <ZapIcon className="w-6 h-6 text-[#4361EE]" data-id="element-22" />
            </div>
            <div className="flex-1 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent" data-id="element-23" />
          </div>
          {/* Mobile divider */}
          <div className="lg:hidden w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-24" />
        </div>

        {/* AFTER — right */}
        <div className="flex-1 relative px-8 sm:px-12 py-16 flex flex-col justify-center" style={{
        background: 'linear-gradient(135deg, #0A1A2E 0%, #0A2D3A 50%, #0A1A2E 100%)'
      }} data-id="element-25">
          {/* Background texture */}
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'repeating-linear-gradient(-45deg, #4361EE 0, #4361EE 1px, transparent 0, transparent 50%)',
          backgroundSize: '20px 20px'
        }} data-id="element-26" />

          <div className="relative max-w-lg mx-auto lg:mr-auto lg:ml-16" data-id="element-27">
            <div className="flex items-center gap-3 mb-8" data-id="element-28">
              <div className="w-3 h-3 rounded-full bg-[#4361EE]" data-id="element-29" />
              <h3 className="text-[#4361EE] text-[52px] sm:text-[64px] leading-none glow-text-blue" style={{
              fontFamily: "'Bebas Neue', sans-serif"
            }} data-id="element-30">
                AFTER ADHD RESET
              </h3>
            </div>

            <div className="space-y-5" data-id="element-31">
              <AfterItem text="Clear morning ritual that launches you into deep focus" data-id="element-32" />
              <AfterItem text="A system that works with your brain, not against it" data-id="element-33" />
              <AfterItem text="Projects actually finished — and shipped" data-id="element-34" />
              <AfterItem text="Deadlines feel manageable, not terrifying" data-id="element-35" />
              <AfterItem text="Confidence that you can do hard things consistently" data-id="element-36" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function BeforeItem({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-4" data-id="element-37">
      <div className="w-6 h-6 rounded-full bg-[#F72585]/20 border border-[#F72585]/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-38">
        <XIcon className="w-3 h-3 text-[#F72585]" data-id="element-39" />
      </div>
      <p className="text-white/80 text-base leading-relaxed" style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-40">
        {text}
      </p>
    </div>;
}
function AfterItem({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-4" data-id="element-41">
      <div className="w-6 h-6 rounded-full bg-[#4361EE]/20 border border-[#4361EE]/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-42">
        <CheckIcon className="w-3 h-3 text-[#4361EE]" data-id="element-43" />
      </div>
      <p className="text-white text-base leading-relaxed font-medium" style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-44">
        {text}
      </p>
    </div>;
}